import { DashboardStat } from '@/types/dashboard';
import { StatCard } from './StatCard';

interface StatsGridProps {
  stats: DashboardStat[];
  columns?: number;
}

export const StatsGrid = ({ stats, columns = 4 }: StatsGridProps) => {
  const gridClass = columns === 3 
    ? 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6' 
    : 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6';

  return (
    <div className={gridClass}>
      {stats.map((stat) => (
        <StatCard
          key={stat.title}
          title={stat.title}
          value={stat.value}
          icon={stat.icon}
          color={stat.color}
          bgColor={stat.bgColor}
        />
      ))}
    </div>
  );
};
